// extracted by mini-css-extract-plugin
export default {"buttonContainer":"CustomButton_buttonContainer__tp0Hp","text":"CustomButton_text__2SQRl"};